import React, { useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./StaffClientsModal.module.scss";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import { CommonMultiSelect, CommonSelect, CstmPagination, RequiredFieldAstrick } from "components/Common/Common";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { CloseIcon } from "Assets/icons";
import { Formik } from "formik";
import { APPOINTMENT_CLIENT_TYPE_OPTIONS } from "config/constants";
import { useAssignConsentFormMutation, useLazyGetConsentFormsListQuery } from "store/services/guardian";
import { successMessageToast } from "helpers/common";
import { APPOINTMENT_FORMS_VIEW } from "config/paths";

const AddConsentFormsModal = ({ show, setShow, parentId, clientId, clientType }) => {

    const [consentFormOptions, setConsentFormOptions] = useState([])
    const [initialValues, setInitialValues] = useState({ consent_form_id: null, clientType: null })

    const [getConsentForms, { isFetching: consentFormListFetching }] = useLazyGetConsentFormsListQuery();
    const [assignConsentForms, { isLoading: assignConsentFormLoading }] = useAssignConsentFormMutation()

    const handlePopup = () => setShow(false)

    const getConsentLookup = async (clientType) => {
        try {
            let result = null;
            if (clientType) {
                result = await getConsentForms({ clientType }).unwrap();
            }
            if (!result?.length) {
                return;
            }
            const options = result?.map((item) => ({ value: item.id, label: item?.title }));
            console.log('result ', options)
            setConsentFormOptions(options)

        } catch (err) {
            console.error("error fetching guardians", err)
        };
    }

    const handleSubmit = async (values) => {
        const body = {
            consent_form_id: values?.consent_form_id?.value,
            parentId,
            clientId
        }
        try {
            const result = await assignConsentForms(body).unwrap()
            successMessageToast(result?.message)
            setShow(false);
        } catch (error) {
            console.log("error assigning consent form", error)
        }
    }
    console.log('clientType', clientType)
    useEffect(() => {
        setInitialValues((prev) => ({ ...prev, clientType: { label: APPOINTMENT_CLIENT_TYPE_OPTIONS?.find((item) => item?.value == clientType)?.label, value: clientType } }))
        getConsentLookup(clientType)
    }, [clientType])


    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <div onClick={handlePopup} style={{ display: "inline-block" }}>
                        <Button

                            className="cursor-pointer border-0 p-0 position-absolute"
                            variant="transparent"
                            style={{ right: 15, top: 10, cursor: "pointer", lineHeight: "0", verticalAlign: "middle" }}
                        >
                            <CloseIcon />
                        </Button>
                    </div>
                    <div>
                        <h6 className="m-0 fw-bold themeBlue">Assign Consent Form</h6>
                    </div>
                    <section
                        className={`${styles.ClientDetail} position-relative ClientDetail`}
                    >
                        <Container fluid>
                            <Row>
                                <Col
                                    lg="12"
                                    className=""
                                >
                                    <Row>
                                        <Col lg="12" className="my-3">
                                            <Formik
                                                initialValues={initialValues}
                                                // validationSchema={appointmentsValidationSchema}
                                                onSubmit={handleSubmit}
                                                enableReinitialize
                                            >
                                                {({
                                                    handleSubmit, values, setFieldValue, errors
                                                }) => (
                                                    <Form onSubmit={handleSubmit}>
                                                        <div
                                                            className="py-3"
                                                        //   style={{ borderTop: "1px solid #41a2a84d" }}
                                                        >
                                                            <Row>
                                                                {
                                                                    <Col md="12" sm="4" className="mt-2">
                                                                        <label className="form-label fw-bold themeBlue d-flex my-2">
                                                                            Client Type
                                                                            <RequiredFieldAstrick />
                                                                        </label>
                                                                        <CommonSelect

                                                                            name={"clientType"}
                                                                            option={APPOINTMENT_CLIENT_TYPE_OPTIONS}
                                                                            placeholder={"Select Client Type"}
                                                                            onChange={(val) => {
                                                                                // setConsentForm([]);
                                                                                // setFieldValue("consentForms", []);
                                                                                // setClientOptions([]);
                                                                                // getClientListLookup(val.value, values?.parentId);
                                                                                getConsentLookup(val.value)
                                                                                // setValues({
                                                                                //   ...values,
                                                                                //   client_type: val,
                                                                                //   client_id: ""
                                                                                // })
                                                                            }}
                                                                            isDisabled={true}
                                                                        />
                                                                    </Col>
                                                                }


                                                                <Col md="12" sm="4" className="mt-2">
                                                                    <label className="form-label fw-bold themeBlue d-flex my-2">
                                                                        Consent Forms
                                                                        <RequiredFieldAstrick />
                                                                    </label>
                                                                    <CommonSelect
                                                                        name={"consent_form_id"}
                                                                        option={consentFormOptions}
                                                                        placeholder={"Select Consent Forms"}
                                                                        isLoading={consentFormListFetching}
                                                                    // onChange={(val) => setFieldValue('consentForm', val)}
                                                                    // onChange={(val) => {
                                                                    //   setClientOptions([]);
                                                                    //   getClientOptions(val);
                                                                    //   setValues({
                                                                    //     ...values,
                                                                    //     client_type: val,
                                                                    //     client_id: ""
                                                                    //   })
                                                                    // }}
                                                                    />
                                                                    {
                                                                        values?.consent_form_id?.value &&
                                                                        <div className="w-100">
                                                                            <table className="w-100">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th style={{ padding: "10px 15px" }}>Name</th>
                                                                                        <th style={{ padding: "10px 15px", textAlign: "center" }}>View</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr className="  ">
                                                                                        <td>{values?.consent_form_id?.label}</td>
                                                                                        <td className="text-end"> <div
                                                                                            className={`${styles.btnWrpper} btnWrpper d-flex justify-content-end align-items-center gap-10 pt-3`}
                                                                                        >
                                                                                            <Button type="button" onClick={() => window.open(generatePath(APPOINTMENT_FORMS_VIEW, { id: values?.consent_form_id?.value, mode: "preview" }), '_blank')} className="d-flex align-items-center justify-content-center commonBtn">
                                                                                                Preview
                                                                                            </Button>
                                                                                        </div></td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>

                                                                        </div>
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        <Row className="mt-4">
                                                            <Col className="my-2" lg="12">
                                                                <div
                                                                    className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                                                                    style={{ borderTop: "1px solid #41a2a84d" }}
                                                                >
                                                                    <Button type="submit" disabled={assignConsentFormLoading} className="d-flex align-items-center justify-content-center commonBtn">
                                                                        {assignConsentFormLoading ? <LoadingIndicator inline /> : "Save"}

                                                                    </Button>
                                                                    {/* <Button
                                                                          type="button"
                                                                          className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                                                                          onClick={() => navigate(MANAGE_PARENTS_LIST)}
                                                                        >
                                                                          Cancel
                                                                        </Button> */}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                        </Container>
                    </section>

                </Modal.Body>
            </Modal >
        </>
    );
};

export default AddConsentFormsModal;